import React from 'react';
import nasrin_selant from '../../images/board/nasrin-selant.png';
import emma_chapman from '../../images/board/emma-chapman.jpg';
import chris_byron from '../../images/board/chris-byron.jpg'
import lewie_wilson from '../../images/board/lewie-wilson.jpg';
import simon_kempson from '../../images/board/simon-kempson.jpg'
import sarah_baron from '../../images/board/sarah-baron.png';

//emma-chapman.jpg
function BoardSub() {
  return (
    <section className="BoardSub-box">
      <div className="BoardSub">
        <div className="BoardSub-item">
          <img src={nasrin_selant} width="70%" height="70%" alt="Max" />
          <h6 className="custom-secondary-color">Nasrin Selant</h6>
          <ul className="ul-one"></ul>
          <p className="member-color">Commercial Analytics Director</p>
        </div>
        <div className="BoardSub-item">
          <img src={emma_chapman} width="70%" height="70%" alt="Emma" />
          <h6 className="custom-secondary-color">Emma Danson</h6>
          <ul className="ul-one ul-two"></ul>
          <p className="member-color">HR Director</p>
        </div>
        <div className="BoardSub-item">
          <img src={chris_byron} width="70%" height="70%" alt="Chris" />
          <h6 className="custom-secondary-color">Chris Byron</h6>
          <ul className="ul-yellow"></ul>
          <p className="member-color">Home Delivery Operations Director</p>
        </div>
        <div className="BoardSub-item">
          <img src={lewie_wilson} width="70%" height="70%" alt="Lewie" />
          <h6 className="custom-secondary-color">Lewie Wilson</h6>
          <ul className="ul-one ul-green"></ul>
          <p className="member-color">Finance Director </p>
        </div>
        <div className="BoardSub-item">
          <img src={simon_kempson} width="70%" height="70%" alt="Simon" />
          <h6 className="custom-secondary-color">Simon Kempston</h6>
          <ul className="ul-yellow"></ul>
          <p className="member-color">Supply Chain Director</p>
        </div>
        <div className="BoardSub-item">
          <img src={sarah_baron} width="70%" height="70%" alt="Sarah" />
          <h6 className="custom-secondary-color">Sarah Baron</h6>
          <ul className="ul-yellow"></ul>
          <p className="member-color">Marketing & Creative Director</p>
        </div>
      </div>
    </section>
  );
}

export default BoardSub;
